import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SessionFormsComponent} from './session-forms.component';
import {SignUpFormModule} from '../sign-up-form/sign-up-form.module';
import {LoginFormModule} from '../login-form/login-form.module';
import {ResetPasswordModule} from '../../../modals/reset-password/reset-password.module';

@NgModule({
  declarations: [SessionFormsComponent],
  exports: [SessionFormsComponent],
  imports: [
    CommonModule,
    SignUpFormModule,
    LoginFormModule,
    ResetPasswordModule,
  ],
})
export class SessionFormsModule { }
